// extracted by mini-css-extract-plugin
export default {"switch_checkbox":"SwitchButton_switch_checkbox__cUG64","switch_label":"SwitchButton_switch_label__6EVFb","switch_button":"SwitchButton_switch_button__4ilz7"};